import React from 'react';
import { Cardapio } from 'modulos/cardapio/containers';

export const CardapioEdicao = () => {
  return <Cardapio visualizacao="cardapio" />;
};
